import type { SxProps } from '@mui/material';

const styles: Record<string, SxProps> = {
  mainContent: {
    minHeight: 'calc(100vh - 200px)', // Ajusta o conteúdo entre o Header e Footer
    py: 4,
    px: 2,
  },
};

export default styles;
